import {SIGN_OUT} from '../state/actionTypes'
import {stateValue, stateMeta, snakeToCamel} from './data'

export const asyncNames = actionName => ({
  loading: `${actionName}_LOADING`,
  success: `${actionName}_SUCCESS`,
  failure: `${actionName}_FAILURE`
})

export const asyncActions = actionName => ({
  loading: bool => ({
    type: asyncNames(actionName).loading,
    data: bool
  }),
  success: ({data, included = [], meta = {}}) => ({
    type: asyncNames(actionName).success,
    data,
    included,
    meta
  }),
  failure: (status, error) => ({
    type: asyncNames(actionName).failure,
    data: {error, status}
  })
})

export const reducerFactory = actionName => {
  const key = snakeToCamel(actionName.toLowerCase());
  const metaKey = `${key}Meta`
  const initialState = {[key]: [], loading: false, error: null, failed: false, [metaKey]: {}}

  return (state = initialState, action) => {
    switch (action.type) {
      case asyncNames(actionName).loading:
        return {...initialState, ...state, loading: action.data}
      case asyncNames(actionName).failure:
        return {...state, loading: false, error: action.data.error, failed: action.data.status}
      case asyncNames(actionName).success:
        return {
          ...state,
          loading: false,
          [key]: stateValue({data: action.data, records: state[key]}),
          [metaKey]: stateMeta({data: action.data, meta: action.meta, prevMeta: state[metaKey]}),
          error: null,
          failed: false
        }
      case asyncNames(SIGN_OUT).success:
        return {...state, [key]: []}
      default:
        return state
    }
  }
}
